import { FC } from 'react';
import { IoCheckmarkCircle } from 'react-icons/io5';

import { useI18nContext } from '../../hooks/contexts/i18n.context';
import styles from './waitlist.module.css';

interface WaitlistSuccessProps {
  onClose : () => void;
}

export const WaitlistSuccess: FC<WaitlistSuccessProps> = ({ onClose }) => {
  const { translate } = useI18nContext();

  return (
    <div className={styles.successContainer}>
      <div className={styles.successBadge}>
        <IoCheckmarkCircle size={20} color="#10B5B0" />
        <span>{translate(['RESALE_LISTING', 'WAITLIST', 'SUCCESS_BADGE'])}</span>
      </div>

      <h2 className={styles.successTitle}>
        {translate(['RESALE_LISTING', 'WAITLIST', 'SUCCESS_TITLE'])}
      </h2>

      <p className={styles.successMessage}>
        {translate(['RESALE_LISTING', 'WAITLIST', 'SUCCESS_SUBTITLE'])}
      </p>

      <button
        type="button"
        className={styles.submitButton}
        onClick={onClose}
      >
        {translate(['RESALE_LISTING', 'WAITLIST', 'CLOSE'])}
      </button>
    </div>
  );
};
